require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-sample-future-retirement.json") })
        }
      }, "path---es-articles-sample-future-retirement");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-sample-future-retirement!./.cache/json/es-articles-sample-future-retirement.json
// module id = 2237
// module chunks = 231608221292675